<h1 mat-dialog-title>Success</h1>
<div mat-dialog-content>
 QA Matrix data is submited successfully. Do you want to navigate to Dashboard?
</div>
<div mat-dialog-actions>
  <button mat-button mat-raised-button color="primary" [mat-dialog-close]="data.id" cdkFocusInitial>Yes</button>
  <button mat-button (click)="onNoClick()">No</button>
</div>


<!-- Copyright 2019 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
